<template>
  <div class="container" :style="styles"></div>
</template>
<script>
import {REPORT_BORDER_RADIUS} from '../constants';

export default {
  inject: ['getBrandPrimaryBackground'],
  computed: {
    styles() {
      const bg = this.getBrandPrimaryBackground();
      return {
        backgroundColor: bg || '#4f4f4f',
        borderRadius: REPORT_BORDER_RADIUS,
        minHeight: 'auto',
      };
    },
  },
};
</script>

<style scoped>
/* ? Temporarily removed from div */
.report__footer {
  height: 60px;
}
</style>
